import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-speech-bubble-empty",
  "use": "icon-speech-bubble-empty-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-speech-bubble-empty\"><path d=\"M11.999 3C12.551 3 13 3.449 13 4v4.995A1.007 1.007 0 0 1 12 10H8.592L6 12.536V10H4a1 1 0 0 1-1-1V4.005A1.007 1.007 0 0 1 4 3zm0-1h-8A2.01 2.01 0 0 0 2 4v5a2 2 0 0 0 2 2h1v3.914L9 11h3a2.01 2.01 0 0 0 2-2V4a2 2 0 0 0-2.001-2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol